import * as model from "./model.js"
import "core-js/stable"
import "regenerator-runtime/runtime"
import searchView from "./views/searchView.js"
import historyView from "./views/historyView.js"
import resultsView from "./views/resultsView.js"
import { cleanHistory } from './helper.js'
import paginationView from "./views/paginationView.js"


/**
 * 
 * @returns {string[]} for Show search results
 */
const controlSearchResults = async () => {
  try {
    resultsView.renderSpinner();
    const query = searchView.getQuery();
    if (!query) {
      resultsView.renderError("Please enter search key word");
      return
    }

    await model.loadSearchResults(query);
    resultsView.render(model.state.search.results)
  } catch (err) {
    console.log(err)
    resultsView.renderError(`We could not find that recipe. please try another one`)
  }
  finally {
  }
}

/**
 * 
 * @param {number} id the id of search result that will be save in localStorage(history) 
 */
const controlAddItemToList = (id) => {
  model.saveToStorage(id);
  historyView.render(model.historyResultPerPage(1))
  paginationView.render(model.state.history);
}
/**
 * expand the search results box
 */
const controlInputFocus = () => {
  searchView.openSearchResults();
}

/**
 * collapse the search results box
 */
const controlInputBlur = () => {
  searchView.closeSearchResults();
}

/**
 * load history data on page load
 */
const controlLoadHistoryItems = () => {
  model.getItemsFromStorage("history");
  historyView.render(model.historyResultPerPage(1))
  paginationView.render(model.state.history);
}

/**
 * clean all history list from localStorage and rerender the history box
 */
const controlCleanHistoryItems = () => {
  cleanHistory();
  model.getItemsFromStorage("history");
  historyView.render(model.historyResultPerPage(1))
  paginationView.render(model.state.history);
}

/**
 * 
 * @param {number} id the id that will be removed from the history list 
 */
const controlRemoveItemFromList = (id) => {
  model.removeItem(id);
  const current = model.historyResultPerPage(model.state.history.page)?.length === 0 ? model.state.history.page - 1 : model.state.history.page;

  historyView.render(model.historyResultPerPage(Math.max(1, current)))
  paginationView.render(model.state.history);
}

/**
 * 
 * @param {number} page the page number that change the pagination and rerender the data of history box 
 */
const controlChangePage = (page) => {
  historyView.render(model.historyResultPerPage(page))
  paginationView.render(model.state.history);

}
const init = function () {
  searchView.addHandlerSearch(controlSearchResults)
  searchView.addFocusSearch(controlInputFocus)
  searchView.addBlurSearch(controlInputBlur)
  resultsView.addItemToList(controlAddItemToList)
  historyView.loadHistory(controlLoadHistoryItems)
  historyView.cleanHistory(controlCleanHistoryItems)
  historyView.removeItem(controlRemoveItemFromList)
  paginationView.clickPaginationItem(controlChangePage)
}

init();



